$(function () {

    window.csp = {};

    window.csp.form = ({

        init: function () {

            var _th = this;

            //$('.js-phone').mask('+7(999) 999-9999');

            $('form').submit(function () {
                if (!_th.checkForm($(this)))
                    return false;
            });
        },

        checkForm: function (form) {
            var checkResult = true;
            form.find('.warning').removeClass('warning');
            form.find('input, textarea, select').each(function () {
                if ($(this).data('req')) {
                    switch ($(this).data('type')) {
                        case 'tel':
                            var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                            if (!re.test($(this).val())) {
                                $(this).addClass('warning');
                                checkResult = false;
                            }
                            break;
                        case 'email':
                            var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
                            if (!re.test($(this).val())) {
                                $(this).addClass('warning');
                                checkResult = false;
                            }
                            break;
                        case 'checkbox_personal':
                            if (!$(this).is(':checked')) {
                                $(this).parents('.checkbox').addClass('warning');
                                checkResult = false;
                            }
                            break;
                        default:
                            if ($.trim($(this).val()) === '') {
                                $(this).addClass('warning');
                                checkResult = false;
                            }
                            break;
                    }
                }
            });
            return checkResult;
        }

    }).init();

    window.csp.map = ({

        init: function initMap() {

            var mapPar = $('#YMapsID');
            if (mapPar.length) {
                var data = mapPar.data('json'),
                    markerIco = '/static/i/svg/pin-map.svg';

                if (data) {
                    var promise = ymaps.ready(function () {
                        var myMap = new ymaps.Map("YMapsID", {
                            center: [data.lat, data.lng],
                            zoom: data.zoom || 12,
                            controls: []
                        });

                        myMap.controls.add('zoomControl', {size: 'small'});
                        myMap.behaviors.disable('scrollZoom');

                        var myPlacemark = new ymaps.Placemark([data.lat, data.lng], {
                            balloonContent: '<strong>' + data.title + '</strong><br>' + data.content
                        }, {
                            iconLayout: 'default#image',
                            iconImageHref: markerIco,
                            iconImageSize: [36, 54]
                        });

                        myMap.geoObjects.add(myPlacemark);
                    });
                }
            }

            var mapRoute = $('.ya-map-rooute');
            if (mapRoute.length) {

                var calculator_form = document.querySelector('.js-calculator-form'),
                    calculator_next = $('.js-calculator-next'),
                    calculator_back = $('.js-calculator-back'),
                    calculator_result = $('.js-calculator-result'),
                    calculator_length = document.querySelector('.js-calculator-length'),
                    calculator_in_city = document.querySelector('.js-calculator-in-city'),
                    calculator_request = $('.js-calculator-request'),
                    in_city = null,
                    calculator_data = {},
                    route_length = 0;

                if (calculator_form) {
                    var clform = new TurboForm(calculator_form, {});
                    clform.showSuccessMessage = function (message) {
                        calculator_result.text(message);
                        $.magnificPopup.close();
                        $.magnificPopup.open({
                            items: {
                                src: '#calc3'
                            },
                            type: 'inline'
                        });
                    };

                    clform.showErrorMessage = function (message) {
                        try {
                            if (this.response[0].errors['rout-length']) {
                                alert('Укажите маршрут');
                            }
                        } catch (e) {
                            alert(message);
                        }
                    };

                    function rusFormBool(val) {
                        return val ? 'да' : 'нет';
                    }

                    function getValueFromInput(input) {
                        var value = input.type === 'checkbox' ? rusFormBool(input.checked) : input.value;
                        if (value === 'true' || value === 'false') {
                            return rusFormBool(value === 'true');
                        }
                        return value;
                    }

                    calculator_request.on('click', function (e) {
                        e.preventDefault();
                        for (var i = 0; i < clform.form.length; i++) {
                            calculator_data[clform.form[i].name] = getValueFromInput(clform.form[i]);
                        }

                        var target_form = document.querySelector(e.target.getAttribute('href') + ' form');
                        if (target_form['cars_data']) {
                            target_form['cars_data'].value = JSON.stringify(calculator_data);
                        } else {
                            var newInput = document.createElement('input');
                            newInput.name = 'cars_data';
                            newInput.type = 'hidden';
                            newInput.value = JSON.stringify(calculator_data);
                            target_form.appendChild(newInput);
                        }
                    });

                    calculator_next.on('click', function (e) {
                        e.preventDefault();
                        clform.onSubmit(e);
                    });

                    calculator_back.on('click', function (e) {
                        e.preventDefault();
                    });
                }

                if ($('#yaMap-rooute').length) {
                    ymaps.ready(function () {
                        var myMap = new ymaps.Map("yaMap-rooute", {
                            center: [55.995448, 92.798322],
                            zoom: 12,
                            controls: []
                        });

                        var dataCordStart = mapRoute.data('coord-start'),
                            dataCordFinish = mapRoute.data('coord-finish');

                        if (dataCordFinish && dataCordStart) {
                            dataCordStart = dataCordStart.split(',');
                            dataCordFinish = dataCordFinish.split(',');

                            var dataLatStart = parseFloat(dataCordStart[0]),
                                dataLngStart = parseFloat(dataCordStart[1]),
                                dataLatFinish = parseFloat(dataCordFinish[0]),
                                dataLngFinish = parseFloat(dataCordFinish[1]),
                                markerIcoStart = '/static/i/svg/pin-a.svg',
                                markerIcoFinish = '/static/i/svg/pin-b.svg';

                            var myPlacemark = new ymaps.Placemark([dataLatStart, dataLngStart], {}, {
                                iconLayout: 'default#image',
                                iconImageHref: markerIcoStart,
                                iconImageSize: [40, 68]
                            });

                            var myPlacemark2 = new ymaps.Placemark([dataLatFinish, dataLngFinish], {}, {
                                iconLayout: 'default#image',
                                iconImageHref: markerIcoFinish,
                                iconImageSize: [40, 68]
                            });

                            myMap.geoObjects.add(myPlacemark);
                            myMap.geoObjects.add(myPlacemark2);

                            myMap.setBounds(myMap.geoObjects.getBounds())
                                .then(function () {
                                    if (myMap.getZoom() < 10) {
                                        myMap.setZoom(10);
                                    }
                                }, function (error) {
                                    console.log(error);
                                });
                        }

                        var routePanelControl = new ymaps.control.RoutePanel({
                            options: {
                                showHeader: true,
                                title: 'Маршрут',
                                maxWidth: '400px',
                                autofocus: true
                            }
                        });

                        // Пользователь сможет построить только автомобильный маршрут.
                        routePanelControl.routePanel.options.set({
                            types: {auto: true},
                        });

                        myMap.controls.add(routePanelControl);

                        // Получим ссылку на маршрут.
                        routePanelControl.routePanel.getRouteAsync().then(function (route) {

                            // Зададим максимально допустимое число маршрутов, возвращаемых мультимаршрутизатором.
                            route.model.setParams({results: 1}, true);

                            // Повесим обработчик на событие построения маршрута.
                            route.model.events.add('requestsuccess', function () {

                                var activeRoute = route.getActiveRoute();
                                if (activeRoute) {
                                    var points = route.getWayPoints(),
                                        toAddress = points.get(1).properties.getAll(),
                                        fromAddress = points.get(0).properties.getAll();

                                    if (toAddress.index < fromAddress.index) {
                                        var swap = toAddress;
                                        toAddress = fromAddress;
                                        fromAddress = swap;
                                    }
                                    calculator_data['route'] = 'от ' + fromAddress.name + ' до ' + toAddress.name;

                                    in_city = toAddress.geocoderMetaData.text.search('Красноярск,') !== -1
                                        && fromAddress.geocoderMetaData.text.search('Красноярск,') !== -1;

                                    if (calculator_in_city) {
                                        calculator_in_city.value = in_city;
                                    }

                                    $('.js-rout-empty').hide();
                                    $('.js-rout-select').show()
                                        .find('.form__selected-address')
                                        .html(
                                            '<span class="form__selected-address-item">\n' +
                                            '<b>От </b> ' + fromAddress.name + '</span>\n' +
                                            '<span class="form__selected-address-item">\n' +
                                            '<b>до</b> ' + toAddress.name + '</span>'
                                        );
                                    // Получим протяженность маршрута.
                                    var length = activeRoute.properties.get("distance"),
                                        // Создадим макет содержимого балуна маршрута.
                                        balloonContentLayout = ymaps.templateLayoutFactory.createClass(
                                            '<span>Расстояние: ' + length.text + '.</span>'
                                        );

                                    route_length = length.value / 1000;
                                    if (calculator_length) {
                                        calculator_length.value = route_length;
                                    }
                                    // Зададим этот макет для содержимого балуна.
                                    route.options.set('routeBalloonContentLayout', balloonContentLayout);
                                    // Откроем балун.
                                    activeRoute.balloon.open();
                                } else {
                                    $('.js-rout-empty').show();
                                    $('.js-rout-select').hide();
                                }
                            });

                        });

                    });
                }
            }
        }

    }).init();

    //выцепляем яблоки, вешаем класс
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
        $('body').addClass('ios')
    }

    function animateDecor(swiperMain) {
        var activeindex = swiperMain.activeIndex + 1,
            nextActiveBtn = $('.index .nav__href[data-nav-animate="' + activeindex + '"]');

        if (nextActiveBtn.length) {
            $('.index .nav__href').removeClass('active');
            nextActiveBtn.addClass('active');
            swiperMain.$el.parents('.wrapper').attr('class', 'wrapper animate-step' + activeindex);
        }
    }

    function eventDescrDot() {

        if ($('.js-dotdot').length) {
            var parItem = $('.js-dotdot');
            parItem.each(function () {
                var _th = $(this),
                    _thHeight = _th.height() + 23,
                    _tTitle = _th.find('.ievent__title'),
                    _tDAte = _th.find('.ievent__date'),
                    _taddress = _th.find('.ievent__address'),
                    _tDescr = _th.find('.ievent__descr'),
                    cutHeight = 0;

                if (_tTitle.length) {
                    _thHeight -= _tTitle.outerHeight(true)
                }

                if (_tDAte.length) {
                    _thHeight -= _tDAte.outerHeight(true)
                }

                if (_taddress.length) {
                    _thHeight -= _taddress.outerHeight(true)
                }

                _tDescr.height(_thHeight).dotdotdot({
                    height: _thHeight + 'px'
                });

            });
        }
    }

    function newsTitleDot() {

        if ($('.js-inews-dotdot').length) {
            var parItem = $('.js-inews-dotdot');
            parItem.each(function () {
                var _th = $(this),
                    _thHeight = _th.height(),
                    _tTop = _th.find('.inews__top'),
                    _tTitle = _th.find('.inews__title-href');

                if (_tTop.length) {
                    _thHeight -= _tTop.outerHeight(true)
                }

                _tTitle.height(_thHeight).dotdotdot({
                    height: _thHeight + 'px'
                });

            });
        }
    }

    if ($('.js-burger').length) {
        $('.js-burger').on('click', function () {
            var _t = $(this),
                $body = $('body'),
                $nav = _t.siblings('nav');

            if (!_t.hasClass('open')) {
                _t.addClass('open')
                $nav.fadeIn(350);
                setTimeout(function () {
                    $body.addClass('open-menu');
                }, 200);
            } else {
                $body.removeClass('open-menu');
                setTimeout(function () {
                    $nav.fadeOut(350);
                    _t.removeClass('open');
                }, 600);
            }

            return false;
        })
    }

    if ($('.js-swiper-vertical').length) {
        var swiper = new Swiper('.js-swiper-vertical', {
            direction: 'vertical',
            speed: 700,
            mousewheel: true,
            grabCursor: true,
            keyboard: true,
            simulateTouch: false,
            allowSwipeToNext: false,
            allowSwipeToPrev: false,
            freeModeMomentumVelocityRatio: 0.5,
            on: {
                slideChangeTransitionStart: function () {
                    animateDecor(this);
                },
                init: function () {
                    animateDecor(this);
                    newsTitleDot();
                    eventDescrDot();
                }
            },
            breakpoints: {
                1464: {
                    autoHeight: true
                }
            }
        });
    }

    if ($('.index .swiper-container').length && $('.js-nav-animate').length) {
        var navPar = $('.js-nav-animate'),
            navBtn = navPar.find('.nav__href');

        navBtn.on('click', function () {
            var _th = $(this),
                _thData = parseInt(_th.data('nav-animate'));

            if (!_th.hasClass('active')) {
                navBtn.removeClass('active');
                _th.addClass('active');
                swiper.slideToLoop((_thData - 1), 800, false);
                _th.parents('.wrapper').attr('class', 'wrapper animate-step' + _thData);

                if (_th.parents('body').hasClass('index') && _th.parents('body').hasClass('open-menu')) {
                    $('body').removeClass('open-menu');
                    setTimeout(function () {
                        $('.nav').fadeOut(350);
                        $('.header__burger').removeClass('open');
                    }, 600);
                }
            }

            return false;
        });
    }

    if ($('.js-swiper-level2').length) {
        var swiperLevel2 = new Swiper('.js-swiper-level2', {
            speed: 700,
            mousewheel: false,
            grabCursor: false,
            simulateTouch: false,
            freeModeMomentumVelocityRatio: 0.5,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

        });
    }

    if ($('.js-swiper-scroll').length) {
        var swiperScroll = new Swiper('.js-swiper-scroll', {
            direction: 'horizontal',
            speed: 150,
            draggable: true,
            slidesPerView: 'auto',
            spaceBetween: 31,
            snapOnRelease: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.js-swiper-scroll .swiper-scrollbar',
                hide: false
            },
            on: {
                reachEnd: function () {
                    this.wrapperEl.closest('.swiper-container').classList.add('last-slide-active');
                },
                fromEdge: function () {
                    this.wrapperEl.closest('.swiper-container').classList.remove('last-slide-active');
                }
            }
        });
    }

    var indexNavSubhref = $('.index .js-nav-animate .nav__subhref');
    if (indexNavSubhref) {
        indexNavSubhref.on('click', function () {
            var _th = $(this),
                _thData = _th.data('subhref'),
                subhrefSlide = $('.swiper-slide[data-subhref-slide="' + _thData + '"]');

            if (_th.attr('data-subhref').length && subhrefSlide.length) {
                _th.parents('.nav__sublist').find('.nav__subhref').removeClass('active');
                _th.addClass('active');
                swiperLevel2.slideToLoop(_thData - 1, 800, false);

                if (!_th.parents('.wrapper').hasClass('animate-step6')) {
                    _th.parents('.wrapper').attr('class', 'wrapper animate-step6');
                } else {
                    _th.parents('.wrapper').attr('class', 'wrapper animate-step3');
                }

                if (_th.parents('body').hasClass('index') && _th.parents('body').hasClass('open-menu')) {
                    $('body').removeClass('open-menu');
                    setTimeout(function () {
                        $('.nav').fadeOut(350);
                        $('.header__burger').removeClass('open');
                    }, 600);
                }
            }

            return false;
        });
    }
    var $selects = $('.js-select');
    if ($selects.length) {
        $selects.styler({
            selectSmartPositioning: false,
        });
    }

    var $modals = $('.js-mfp');
    if ($modals) {
        var modalsOpened = [];
        $modals.magnificPopup({
            type: 'inline',
            midClick: true,
            callbacks: {
                afterClose: function () {
                    // выплевываем текущею модалку
                    modalsOpened.pop();
                    if (modalsOpened.length > 0) {
                        var oldModal = modalsOpened.pop();
                        oldModal.click();
                    }
                }
            }
        });

        $modals.on('click', function (e) {
            modalsOpened.push(e.target);
            var hash = e.currentTarget.href.split('#');
            if (hash.length === 2) {
                hash = '#' + hash[1];
                $(hash).find('input[name=category]').val($(e.currentTarget).attr('data-category') === 'true' ? 'Event' : null);
            }
        });
    }

    var datepicker = $('.js-datepicker');
    if (datepicker.length) {
        var date_input = $('.js-filter').find('input[name=calendar]');
        const options = datepicker.data('datepickerOptions')
        const defaultOptions = {
            inline: true,
            multipleDates: true,
            onRenderCell: function (date, cellType) {
                var nameDays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                    currentDate = date.getDate(),
                    currentDay = nameDays[date.getDay()];
                if (cellType === 'day') {
                    return {
                        html: '<span class="dp-day">' + currentDay + '</span>' + currentDate
                    }
                }
            },
            onChangeView: function (view) {
                $('.datepicker--cell-month').each(function () {
                    var curMonth = parseInt($(this).data('month')) + 1;
                    $(this).html('<span class="dp-day">' + curMonth + '</span>' + $(this).text());
                });

                $('select.js-select').val(view).trigger('refresh');
                datepicker.data('datepicker').update({minView: view}).clear();
            },
            onSelect: function (formattedDate, date, inst) {
                if (date) {
                    this.weekly && setWeekAndYearInputs(date)
                    date = this.multipleDates ? date.sort(function (a, b) {
                            return a - b;
                        }) : [date]
                    date_input.val(JSON.stringify({
                        view: datepicker.data('datepicker').view,
                        dates: date.map(function (item) {
                            return new Date(Date.UTC(item.getFullYear(), item.getMonth(), item.getDate(), item.getHours(), item.getMinutes()))
                        })
                    }))
                } else {
                    date_input.val(JSON.stringify({
                        view: datepicker.data('datepicker').view,
                        dates: []
                    }))
                }
            }
        }
        function setWeekAndYearInputs(date) {
            const { year, week } = getYearAndWeekNumber(date)
            const filter = $('.js-filter')
            filter.find('[name=week]').val(week)
            filter.find('[name=year]').val(year)
        }

        datepicker.datepicker({...defaultOptions, ...options});
        try {
            if (date_input.val()) {
                var dates = JSON.parse(date_input.val());
                if (dates && dates.hasOwnProperty('view')) {
                    datepicker.data('datepicker').view = dates.view;
                    dates = dates.dates.map(function (item) {
                        return new Date(item);
                    });
                    datepicker.data('datepicker').selectDate(dates);
                }
            }
        } catch (e) {
            console.error('Calendar init fail');
            console.error(e);
        }

        $('select.js-select').on('change', function () {
            var _thValue = $(this)["0"].value;
            datepicker.data('datepicker').view = _thValue;
            datepicker.data('datepicker').update({minView: _thValue}).clear();
        });

        window._DATE_PICKER = datepicker;

        const filter = $('.js-filter')
        const actions = $('.js-actions')
        const items = $('.js-items')
        const paginator = $('.js-pagination')
        const searchCounter = $('.js-search-counter')

        if (filter.length && actions.length && items.length && paginator.length) {
            new TagCalendarFilter(filter, actions, items, paginator, searchCounter)
        }
    }

    var $tile_scroll = $('.js-tile-scroll');
    if ($tile_scroll.length) {

        var sctollLeft = 0;
        var tileItem = $('.ievent__tile-day');
        var tileWidth = tileItem.width();
        $('.ievent__tile-scroll').on('mousemove', function (e) {
            var _th = $(this),
                parentOffset = _th.parent().offset(),
                relX = e.pageX - parentOffset.left,
                countTile = parseInt((relX + Math.abs(sctollLeft)) / tileWidth);
            tileItem.removeClass('active').eq(countTile).addClass('active');
        }).on('mouseleave', function () {
            tileItem.removeClass('active');
        });

        if ($(window).width() > 1024) {
            var dragging = false, scrolled = false;
            $tile_scroll.mCustomScrollbar({
                axis: "x",
                horizontalScroll: false,
                live: "on",
                documentTouchScroll: true,
                mouseWheel: {axis: "x", preventDefault: false},
                keyboard: {
                    enable: true
                },
                contentTouchScroll: 25,
                advanced: {
                    updateOnBrowserResize: true,
                    autoScrollOnFocus: true,
                    updateOnContentResize: true
                },
                callbacks: {
                    onScroll: function () {
                        scrolled = false;
                    },
                    onInit: function () {
                        sctollLeft = this.mcs.left;
                        var startX = 0;
                        var cur_day = $('.current_day'),
                            $this = $(this);
                        if (cur_day.length) {
                            $this.mCustomScrollbar("scrollTo", {x: cur_day.position().left})
                        }
                        $tile_scroll.on('mousedown', function (e) {
                            dragging = true;
                            startX = e.pageX;
                        });
                        $tile_scroll.on('mousemove', function (e) {
                            if (dragging && !scrolled) {
                                var delta = e.pageX - startX;
                                if (Math.abs(delta) > 5) {
                                    scrolled = true;
                                    try {
                                        $this.mCustomScrollbar("scrollTo", {x: sctollLeft + (delta)}, {
                                            scrollInertia: 0,
                                            scrollEasing: 'none',
                                            timeout: 0,
                                            callbacks: true
                                        });
                                    } catch (e) {
                                        console.log(e);
                                        scrolled = false
                                    }
                                    startX = e.pageX;
                                }
                            }
                        });
                        $tile_scroll.on('mouseup', function (e) {
                            dragging = false;
                        });

                        tileItem.on('click', function () {
                            $this.mCustomScrollbar("scrollTo", {x: $(this).position().left});
                        });

                    },
                    whileScrolling: function () {
                        sctollLeft = this.mcs.left;
                    }
                }
            });
        } else {
            if ($('.js-tile-scroll.mCustomScrollbar').length) {
                $tile_scroll.mCustomScrollbar("destroy");
            }
            var cur_day = $('.current_day');
            if (cur_day.length) {
                sctollLeft = cur_day.offset().left;
                $tile_scroll.animate({
                    scrollLeft: cur_day.offset().left
                }, 700);
            }
        }
    }

    if ($(".js-lightgallery").length) {
        $(".js-lightgallery").lightGallery({
            selector: 'a',
        });
    }

    if ($(".js-auto-gallery").length) {
        $(".js-auto-gallery").lightGallery({
            selector: 'a'
        });
    }

    if ($(".auto__photo").length) {
        $(".auto__photo").on('click', function () {
            $(this).siblings('.auto__gallery').find('.auto__gallery-href').first().trigger('click');
            return false;
        });
    }

    if ($('.js-tipsy').length) {
        $('.js-tipsy').tipsy({gravity: 's', offset: 5, opacity: 1});
    }

    $('.js-close-popup').on('click', function () {
        $.magnificPopup.close();
        return false;
    });

    if ($('.js-tabs').length) {
        var tbsBtn = $('.js-tabs').find('.tabs__nav-bnt'),
            tbsItem = $('.js-tabs').find('.tabs__list-item');

        tbsBtn.on('click', function () {
            var _t = $(this),
                _tData = _t.data('tabs-nav');

            if (!_t.hasClass('active')) {
                tbsBtn.removeClass('active');
                _t.addClass('active');
                tbsItem.fadeOut(350);
                setTimeout(function () {
                    tbsItem.removeClass('active');
                    $('.js-tabs .tabs__list-item[data-tabs-item="' + _tData + '"]').fadeIn(350);
                }, 350);
            }

            return false;
        });

    }

    var $contentTables = $("table", ".text");

    if ($contentTables.length) {
        $contentTables.each(function () {
            $(this).wrap('<div class="table-wrap">');
        });
    }

    $('.form__input, .form__textarea').on('change', function () {
        if ($(this).val() != '') {
            $(this).addClass('no-empty');
        } else {
            $(this).removeClass('no-empty');
        }
    }).change();

    console.log('%cMETA', 'font-size: 100px; font-weight:700;');
});
